import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgGeluidsoverlast = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M20 18.9a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M20 18.9a6 6 0 0 1 6 6v6.17H14V24.9a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M19.98 14.255a3.02 3.02 0 0 0-3.003 2.698l-.994-.106a4.02 4.02 0 0 1 7.994 0l-.994.106a3.02 3.02 0 0 0-3.003-2.698"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m19.98 34.9-8.67-1.66-1.9-11.41 10.57 1.66zM28.64 33.24l-8.66 1.66V23.49l10.56-1.66z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M10 32.9a2 2 0 1 0 0-4 2 2 0 0 0 0 4M30 32.9a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m8.47 12.012 1.77.7 1.575-.627.37.93-1.944.773-1.77-.7-1.762.7-1.935-.774.372-.928 1.565.626zM10.027 8.049 8.794 9.11l-1.438-.01-1.079.939H4.66v-1h1.243l1.081-.941 1.442.01.947-.818zM4.588 16.104l.664-.748.92.817 1.41.02 1.07.94 1.235.017-.014 1-1.604-.023-1.07-.94-1.412-.02z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgGeluidsoverlast);

export default ForwardRef;
